// src/components/TopBar.js
import React, { useState, useEffect } from "react";
import { UserIcon, LockClosedIcon, CogIcon, Bars3Icon } from "@heroicons/react/24/solid";
import supabase from "../../../supabaseClient"; // Correctly import supabase
import UserProfileModal from "./UserProfileModal";

const TopBar = ({ toggleSidebar }) => {
  const [user, setUser] = useState(null);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        const { user } = session;
        setUser({
          displayName: user.user_metadata.full_name || '',
          email: user.email,
          phoneNumber: user.user_metadata.phone || '',
          uid: user.id,
          verifiedStatus: user.email_confirmed_at ? true : false,
        });
      }
    };

    fetchUserData();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        const { user } = session;
        setUser({
          displayName: user.user_metadata.full_name || '',
          email: user.email,
          phoneNumber: user.user_metadata.phone || '',
          uid: user.id,
          verifiedStatus: user.email_confirmed_at ? true : false,
        });
      } else {
        setUser(null);
      }
    });

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error("Error logging out:", error.message);
    }
    // Optionally, navigate to login page
  };

  const toggleProfileModal = () => {
    setIsProfileModalOpen(!isProfileModalOpen);
  };

  return (
    <>
      <div className="bg-gray-900 p-2 px-3 flex items-center text-white w-full fixed top-0 left-0 z-50 grid grid-cols-3">
        {/* Sidebar Toggle Button (visible on mobile) */}
        <div className="flex items-center justify-start">
          <button onClick={toggleSidebar} className="p-2 rounded-md text-white md:hidden focus:outline-none">
            <Bars3Icon className="h-6 w-6" />
          </button>
        </div>

        {/* Centered Logo */}
        <div className="flex justify-center">
          <img src={require("./../../../images/HouvalLight.png")} alt="Logo" className="h-12" />
        </div>

        {/* Profile and Logout Buttons */}
        <div className="flex justify-end items-center">
          <button onClick={toggleProfileModal} className="flex items-center focus:outline-none">
            <UserIcon className="h-5 w-5 mr-1" aria-hidden="true" />
            <span className="hidden lg:block">Profile</span> {/* Text visible on large screens */}
          </button>
          <UserProfileModal user={user} isOpen={isProfileModalOpen} onClose={toggleProfileModal} />

          <button onClick={handleLogout} className="flex items-center ml-4 focus:outline-none">
            <LockClosedIcon className="h-5 w-5 mr-1" aria-hidden="true" />
            <span className="hidden lg:block">Logout</span> {/* Text visible on large screens */}
          </button>
        </div>
      </div>
    </>
  );
};

export default TopBar;
